import {
  View,
  Text,
  StyleSheet,
  Pressable,
  Image,
  Keyboard,
  useWindowDimensions,
  BackHandler,
  Platform,
  TouchableOpacity,
  FlatList,
  ActivityIndicator,
  TextInput,
} from 'react-native';
import { WEB_MAX_CONTENT_WIDTH } from '../../theme/webLayoutWidths';
import { AppAlert } from '../../services/AppAlert';
import React, { useContext, useState, useEffect, useMemo } from 'react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useAuth from '../../hooks/useAuth';
import Receipt from './components/Receipt';
import Button from '../../components/Reusables/Button';
import { ModalContext } from '../../Context/modalContext';
import PaymentModal from '../../components/Modals/PaymentModal';
import Indicator from '../../components/Reusables/Indicator';
import { useRef } from 'react';
import { ExtrasContext } from '../../Context/ExtrasContext';
// import MpesaPayments from "./components/MpesaPayments";
import ErrorContext from '../../Context/ErrorContext';
import { CustomRadioButton } from '../../components/Reusables/RadioButtons';
import { KeyboardStickyView } from 'react-native-keyboard-controller';
import KeyboardAwareFormScroll from '../../components/Reusables/KeyboardAwareFormScroll';
import TestLocationBanner from '../../components/Reusables/TestLocationBanner';
import { useDispatch } from 'react-redux';
import { setUpdatingCartitems } from '../../redux/cartSlice';
import { clearOrderDetails } from '../../redux/orderDetailsSlice';
import { prioritizeProductsByProductObject } from '../../redux/productSlice';
import { addPreviouspendingOrder } from '../../redux/OrdersSlice';
import { useAppSelector } from '../../redux/helper';
import { useSaleActivation } from '../../hooks/useSaleActivation';
import { canEmployeeCheckout } from '../../utils/roles';
import appAnalytics from '../../services/appAnalytics';
import { buildAppAnalyticsContext } from '../../services/appAnalyticsContext';
import { fs, s, v, borderWidth } from '../../utils/libs';
import CustomBottomSheet from '../../components/Reusables/bottomSheet/CustomBottomSheet';
import { BottomSheetModal, BottomSheetTextInput } from '@gorhom/bottom-sheet';
import { useFocusEffect } from '@react-navigation/native';
// import PartialPaymentModal from "./components/PartialPaymentModal";
import Typography from '../../components/Reusables/Typography';
import Feather from '@react-native-vector-icons/feather/static';
import { addPartialPaymentsDetails } from '../../redux/partialPaymentsSlice';
import { SettingsDetails } from '../../redux/SettingsSlice';
import {
  formatWithCommas,
  formatNumericStringWithCommas,
  iconSize,
  sanitizeNumericInput,
  normalizeSafaricomPhone,
  safaricomNumberValidation,
  replaceCurrencyString,
} from '../../utils/libs';
import { isTablet } from 'react-native-device-info';
import { GTFonts, theme } from '../../theme';
import PhoneInput, {
  ICountry,
  IPhoneInputRef,
} from 'rn-international-phone-number';
import {
  PREFERRED_COUNTRIES,
  buildE164FromInput,
  derivePhoneInputFromValue,
} from '../../utils/phone';
import { useDetectedCountry } from '../../hooks/useDetectedCountry';
import { shouldUseWebLayout } from '../../utils/layoutUtils';
import { addMpesaPayments } from '../../redux/mpesaPaymentSlice';
import {
  resetCheckoutPaymentIntent,
  setCheckoutPaymentIntent,
  setCheckoutPaymentSelection,
} from '../../redux/checkoutSlice';
import {
  getUnapprovedMpesaPayments,
  makeMpesaStkPush,
  checkMpesaPaymentsByPhone,
} from '../../api/mpesa';
import OrderCustomerStaffSection from '../../components/Modals/OrderCustomerStaffSection';
import { selectMergedCustomers } from '../../redux/OrdersSlice';
import {
  fetchAssignableStaffForLocation,
  selectAssignableStaffForLocation,
} from '../../redux/assignableStaffSlice';
// Remove the animated imports since they're causing the issue
// import Animated, { useAnimatedStyle } from 'react-native-reanimated';

export { requestBluetoothPermissions } from '../../utils/bluetoothPermissions';

const Checkout = ({ route, navigation }: { route: any; navigation: any }) => {
  const localInputRef = useRef<TextInput | null>(null);
  const orderCustomerName = useAppSelector(
    state => state.cart.cartOrderData.customerName,
  );
  const settings = useAppSelector(SettingsDetails);
  const MpesaBottomSheetModalRef = useRef<BottomSheetModal>(null);
  const dispatch = useDispatch();
  const {
    order,
    orderID,
    Payment_Information: payment_Info,
    ReceiptID,
  } = route.params;
  const [Payment_Information, setPayment_Information] = useState<any>({});
  const { paymentModal, setPaymentModal, assignedStaffId, setAssignedStaffId } =
    useContext(ModalContext);
  const { handleError, resetSnackMessage } = useContext(ErrorContext);
  const { setReceipt, networkAvailableGlobal } = useContext(ExtrasContext);
  const [keyboardVisible, setKeyboardVisible] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState({});
  const [toBePaid, setToBePaid] = useState<number | undefined>(undefined);
  const [payForSelectedItemsOnly, setPayForSelectedItemsOnly] = useState(false);
  const { setTextInputError } = useContext(ErrorContext);

  const [payment, setPayment] = useState({
    cash: true,
    mpesa: false,
    payLater: false,
  });
  const [checkoutSheetTab, setCheckoutSheetTab] = useState<
    'PAYMENTS' | 'CUSTOMER_STAFF'
  >('PAYMENTS');
  // Mpesa setup flag
  const mpesaconfiguration = useAppSelector(state => state.mpesaConfig.fetched);
  const mpesaconfigured = useMemo(() => {
    return mpesaconfiguration && mpesaconfiguration._id;
  }, [mpesaconfiguration]);

  // Mpesa bottom sheet state
  const [mpesaActiveTab, setMpesaActiveTab] = useState<'STK' | 'LATEST'>('STK');
  const [mpesaKeepExpanded, setMpesaKeepExpanded] = useState(false); // once 60%, always 60% for session
  const [mpesaPhone, setMpesaPhone] = useState('');
  const [bottomSheetIndex, setBottomSheetIndex] = useState<number>(-1);
  const [isSendingStk, setIsSendingStk] = useState(false);
  const [isFetchingTx, setIsFetchingTx] = useState(false);
  const [confirmingPhone, setConfirmingPhone] = useState<string | null>(null);
  const mpesaPayments = useAppSelector(state => state.mpesapayments.payments);
  const checkoutPaymentIntent = useAppSelector(
    state => state.checkout.paymentIntent,
  );
  const checkoutPaymentSelection = useAppSelector(
    state => state.checkout.paymentSelection,
  );
  const paymentIntentHydratedRef = useRef(false);

  // Phone input state for international phone picker
  const [phoneInputValue, setPhoneInputValue] = useState<string>('');
  const [phoneSelectedCountry, setPhoneSelectedCountry] = useState<
    ICountry | undefined
  >(undefined);
  const phoneInputRef = useRef<IPhoneInputRef | null>(null);
  const { countryCode, iCountry } = useDetectedCountry();
  const currency = useAppSelector(
    state =>
      state.location.currentLocation?.bp_location_settings
        ?.bp_location_currency || 'KES',
  );
  const currencyTextCapital = useMemo(
    () => replaceCurrencyString('Ksh', currency),
    [currency],
  );

  const { width, height } = useWindowDimensions();
  const useWideCheckoutLayout = shouldUseWebLayout(width, height);
  const styles = useMemo(
    () => createCheckoutStyles(useWideCheckoutLayout),
    [useWideCheckoutLayout],
  );
  const axiosprivate = useAxiosPrivate();
  const { auth } = useAuth();
  const topCustomers = useAppSelector(selectMergedCustomers);
  const currentLocation = useAppSelector(state => state.location.currentLocation);
  const locationId = String(currentLocation?._id || '');
  const { report: reportSaleActivation } = useSaleActivation();
  const assignableStaffEntry = useAppSelector(state =>
    selectAssignableStaffForLocation(state, locationId),
  );
  const [customerTabInput, setCustomerTabInput] = useState(
    orderCustomerName || '',
  );
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [staffQuery, setStaffQuery] = useState('');
  const allowStaffOrderAssignmentSetting = useAppSelector(
    state => state.settings.settings.allow_staff_order_assignment,
  );
  const isStaffAssignmentEnabled = useMemo(() => {
    const fromLocation =
      currentLocation?.bp_location_settings?.bp_location_allow_staff_order_assignment;
    if (typeof fromLocation === 'boolean') return fromLocation;
    return Boolean(allowStaffOrderAssignmentSetting);
  }, [
    currentLocation?.bp_location_settings?.bp_location_allow_staff_order_assignment,
    allowStaffOrderAssignmentSetting,
  ]);
  const filteredCustomers = useMemo(() => {
    const source = topCustomers || [];
    const searchTerm = customerTabInput.trim().toLowerCase();
    if (!searchTerm) return source;
    return source.filter(c => c.name.toLowerCase().includes(searchTerm));
  }, [topCustomers, customerTabInput]);
  const filteredStaff = useMemo(() => {
    const source = assignableStaffEntry.staff || [];
    const search = staffQuery.trim().toLowerCase();
    if (!search) return source;
    return source.filter(staff => {
      const nameMatch = staff.name.toLowerCase().includes(search);
      const roleMatch = staff.role.toLowerCase().includes(search);
      return nameMatch || roleMatch;
    });
  }, [assignableStaffEntry.staff, staffQuery]);
  const shouldShowStaffSection =
    isStaffAssignmentEnabled && !assignableStaffEntry.featureDisabled;

  useEffect(() => {
    if (
      checkoutSheetTab !== 'CUSTOMER_STAFF' ||
      !locationId ||
      !auth?.accessToken ||
      !isStaffAssignmentEnabled
    ) {
      return;
    }
    if (
      assignableStaffEntry.loading ||
      assignableStaffEntry.featureDisabled ||
      !!assignableStaffEntry.fetchedAt ||
      !!assignableStaffEntry.error
    ) {
      return;
    }
    dispatch(
      fetchAssignableStaffForLocation({
        axiosinstance: axiosprivate as any,
        auth,
        locationId,
      }) as any,
    );
  }, [
    checkoutSheetTab,
    locationId,
    auth?.accessToken,
    isStaffAssignmentEnabled,
    assignableStaffEntry.loading,
    assignableStaffEntry.featureDisabled,
    assignableStaffEntry.fetchedAt,
    assignableStaffEntry.error,
    dispatch,
    axiosprivate,
  ]);

  useEffect(() => {
    if (!mpesaconfigured) {
      setMpesaActiveTab('LATEST');
    }
  }, [mpesaconfigured]);

  // Initialize selected country from detected SIM/IP
  useEffect(() => {
    if (!phoneSelectedCountry && iCountry) {
      setPhoneSelectedCountry(iCountry);
    }
  }, [phoneSelectedCountry, iCountry]);

  // Roles that cannot complete a sale (e.g. waiter) must never reach checkout,
  // even via deep-link / programmatic navigation.
  const employeeRole = useAppSelector(
    state => state.auth.inApp.account.employeeInfo?.bp_employee_role,
  );
  const canCheckout = canEmployeeCheckout(employeeRole);
  useEffect(() => {
    if (!canCheckout) {
      navigation.goBack();
    }
  }, [canCheckout, navigation]);

  // Remove this line that's causing the issue:
  // const { height: keyboardHeight } = useKeyboardAnimation();

  useFocusEffect(
    React.useCallback(() => {
      const backHandler = BackHandler.addEventListener(
        'hardwareBackPress',
        handlehardwareBackPress,
      );

      return () => {
        backHandler.remove();
        resetSnackMessage();
      };
    }, []),
  );
  useEffect(() => {
    if (payment_Info) {
      setPayment_Information(payment_Info);
    }
    //reset textInputError,  can use it in partial flow
    setTextInputError({});
  }, [payment_Info]);

  const handlehardwareBackPress = () => {
    const productinfo = order.map((od: any) => od.bp_product_information);
    const cartItems = order?.map((item: any) => ({
      variantId:
        item.bp_product_information?.bp_variant_id ?? item.bp_variant_id,
      Quantity: item.bp_order_quantity,
      mass: item.bp_order_mass,
      itemname: item.bp_product_information.bp_product_name,
      unitofmass: item.bp_product_information.bp_product_unit_of_mass,
      price: item.bp_product_information.bp_product_selling_price,
      productID: item.bp_product_information._id,
      size: item.bp_product_information.bp_product_size,
      model: item.bp_product_information.bp_product_model,
      image: item.bp_product_information.bp_product_image,
      quantity: item.bp_product_information.bp_product_quantity,
      price_type: item.bp_product_information.bp_product_price_type,
      bp_order_paid_quantity: item.bp_order_paid_quantity,
      bp_order_paid_mass: item.bp_order_paid_mass,
    }));
    console.log('productinfo is ', productinfo);
    const proceed = () => {
      appAnalytics.track('commerce_checkout_cancelled', {
        ...buildAppAnalyticsContext({
          role: employeeRole,
          locationType: currentLocation?.bp_location_is_system_generated
            ? 'test'
            : currentLocation
              ? 'real'
              : undefined,
        }),
        reason: 'hardware_back',
      });
      dispatch(prioritizeProductsByProductObject(productinfo));
      dispatch(setUpdatingCartitems(true));
      (dispatch(addPreviouspendingOrder(cartItems)),
        navigation.navigate('MainScreen', {
          screen: 'ProductsScreen',
          params: {
            from: 'Checkout',
          },
        }));
    };

    AppAlert.alert(
      'Cancel Order ?',
      'The order will be saved and marked incomplete',
      [
        {
          text: 'Cancel',
          onPress: () => null,
          style: 'cancel',
        },
        {
          text: 'Continue',
          onPress: proceed,
        },
      ],
    );
    return true;
  };

  useEffect(() => {
    setReceipt({
      order: order,
      orderID: orderID,
      Payment_Information: {
        bp_payment_amount: payment_Info?.bp_payment_amount,
        bp_payment_amount_due: payment_Info?.bp_payment_amount_due,
        bp_payment_already_paid_amount:
          payment_Info?.bp_payment_already_paid_amount,
      },
      ReceiptID: ReceiptID,
    });
  }, [order, orderID, payment_Info]);

  useEffect(() => {
    if (Payment_Information?.bp_payment_amount) {
      const amountReceived =
        // cases where we creating order not updating
        Payment_Information.bp_payment_already_paid_amount ?? 0;

      setToBePaid(Payment_Information.bp_payment_amount - amountReceived);
    }
  }, [Payment_Information?.bp_payment_amount, route.params]);

  useEffect(() => {
    if (!checkoutPaymentIntent || paymentIntentHydratedRef.current) {
      return;
    }
    if (checkoutPaymentIntent.method === 'mpesa') {
      setPayment({ cash: false, mpesa: true, payLater: false });
      dispatch(
        setCheckoutPaymentSelection({
          cash: false,
          mpesa: true,
          payLater: false,
        }),
      );
      if (checkoutPaymentIntent.mpesa.phone) {
        setMpesaPhone(checkoutPaymentIntent.mpesa.phone);

        // Initialize phone input UI from stored phone number
        const derived = derivePhoneInputFromValue(
          checkoutPaymentIntent.mpesa.phone,
        );
        if (derived.country) {
          setPhoneSelectedCountry(derived.country);
        }
        setPhoneInputValue(derived.nationalNumber);
      } else {
        setPhoneInputValue('');
      }
      setMpesaActiveTab(
        checkoutPaymentIntent.mpesa.mode === 'PAID_TO_TILL' ? 'LATEST' : 'STK',
      );
      if (checkoutPaymentIntent.cashAmount) {
        setInput(
          sanitizeNumericInput(checkoutPaymentIntent.cashAmount, {
            isUnit: true,
          }),
        );
      }
    } else if (checkoutPaymentIntent.method === 'cash') {
      setPayment({ cash: true, mpesa: false, payLater: false });
      dispatch(
        setCheckoutPaymentSelection({
          cash: true,
          mpesa: false,
          payLater: false,
        }),
      );
      if (checkoutPaymentIntent.cashAmount) {
        setInput(
          sanitizeNumericInput(checkoutPaymentIntent.cashAmount, {
            isUnit: true,
          }),
        );
      }
    } else if (checkoutPaymentIntent.method === 'pay_later') {
      setPayment({ cash: false, mpesa: false, payLater: true });
      dispatch(
        setCheckoutPaymentSelection({
          cash: false,
          mpesa: false,
          payLater: true,
        }),
      );
    }
    paymentIntentHydratedRef.current = true;
  }, [checkoutPaymentIntent, dispatch]);

  const [input, setInput] = useState('');

  useEffect(() => {
    if (payment.cash) {
      dispatch(
        setCheckoutPaymentIntent({
          method: 'cash',
          cashAmount: input,
        }),
      );
      return;
    }

    // Mpesa Till Payment uses the same amount-received input.
    if (payment.mpesa && mpesaActiveTab === 'LATEST' && !mpesaconfigured) {
      dispatch(
        setCheckoutPaymentIntent({
          method: 'mpesa',
          cashAmount: input,
          mpesa: { mode: 'PAID_TO_TILL' },
        }),
      );
    }
  }, [
    dispatch,
    input,
    mpesaActiveTab,
    mpesaconfigured,
    payment.cash,
    payment.mpesa,
  ]);

  useEffect(() => {
    if (payment.mpesa) {
      dispatch(
        setCheckoutPaymentIntent({
          method: 'mpesa',
          mpesa: {
            phone: normalizeSafaricomPhone(mpesaPhone),
          },
        }),
      );
    }
  }, [mpesaPhone, payment.mpesa, dispatch]);

  useEffect(() => {
    if (payment.mpesa) {
      dispatch(
        setCheckoutPaymentIntent({
          mpesa: {
            mode: mpesaActiveTab === 'LATEST' ? 'PAID_TO_TILL' : 'STK',
          },
        }),
      );
    }
  }, [mpesaActiveTab, payment.mpesa, dispatch]);

  useEffect(() => {
    if (!checkoutPaymentSelection) {
      return;
    }
    setPayment(prev => ({
      cash: checkoutPaymentSelection.cash ?? prev.cash,
      mpesa: checkoutPaymentSelection.mpesa ?? prev.mpesa,
      payLater: checkoutPaymentSelection.payLater ?? prev.payLater,
    }));
  }, [checkoutPaymentSelection]);

  const checkMaxAllowedAmount = (toBePaid: number, inputAmount: number) => {
    // Define thresholds for different bill ranges
    const thresholds = [
      { max: 10, multiplier: 100 },
      { max: 100, multiplier: 20 },
      { max: 500, multiplier: 10 },
      { max: 1000, multiplier: 5 },
      { max: 5000, multiplier: 3 },
      { max: Infinity, multiplier: 2 },
    ];

    // Find the appropriate threshold
    const threshold = thresholds.find(t => toBePaid <= t.max);
    const maxAllowedAmount = toBePaid * (threshold?.multiplier || 1);

    if (inputAmount > maxAllowedAmount) {
      return true;
    }
    return false;
  };

  const payByCash = async (amountPaid: string) => {
    const sanitizedAmount = sanitizeNumericInput(amountPaid, { isUnit: true });
    setIsLoading(true);
    try {
      const response = await axiosprivate.post(
        'bp_cash_payment_information',
        JSON.stringify({
          bp_order_id: orderID,
          bp_amount_paid: sanitizedAmount,
          bp_payment_method: payment.cash ? 'Cash' : 'Mpesa',
        }),
        {
          headers: { Authorization: 'Bearer ' + auth?.accessToken },
        },
      );
      console.log('payByCash response is ', response);
      if (response?.data?.status === 200) {
        setPaymentInfo(response.data.data);
        setPayment_Information(response.data.data.payment);
        setReceipt(prev => ({
          ...prev,
          Payment_Information: response.data.data.payment,
        }));
        // Capture amounts before PaymentModal mounts and ClearCart runs.
        const amountPaidNum = Number(sanitizedAmount);
        const paymentMethod = payment.cash ? 'cash' : 'mpesa';
        appAnalytics.track('commerce_checkout_completed', {
          ...buildAppAnalyticsContext({
            role: employeeRole,
            locationType: currentLocation?.bp_location_is_system_generated
              ? 'test'
              : currentLocation
                ? 'real'
                : undefined,
          }),
          item_count: order?.length,
          amount_paid: Number.isFinite(amountPaidNum)
            ? amountPaidNum
            : undefined,
          order_total:
            Payment_Information?.bp_payment_amount ??
            payment_Info?.bp_payment_amount,
          payment_method: paymentMethod,
          ...(paymentMethod === 'mpesa'
            ? {
                mpesa_mode:
                  mpesaActiveTab === 'LATEST' ? 'paid_to_till' : 'stk',
              }
            : {}),
          order_id: orderID,
          flow: 'standard',
        });
        // T077: terminal real-location standard sale success → First sale.
        reportSaleActivation({
          flow: 'standard',
          responseStatus: response?.data?.status,
          paymentStatus: response?.data?.data?.payment?.bp_payment_status,
          locationId,
          locationType: currentLocation?.bp_location_is_system_generated
            ? 'test'
            : 'real',
        });
        dispatch(clearOrderDetails());
        dispatch(resetCheckoutPaymentIntent());
        setPaymentModal(true);
      } else {
        console.log('error found');
        handleError(response.data.message, 'error', true);
      }
    } catch (error) {
      console.log(error);
      handleError('Payment unsuccessful, please try again', 'error', true);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaybyCash = () => {
    const sanitized = sanitizeNumericInput(input, { isUnit: true });
    const inputAmount = parseFloat(sanitized);
    // && inputAmount >= billAmount
    if (inputAmount && toBePaid && inputAmount >= toBePaid) {
      const hasMaxAllowedAmount = checkMaxAllowedAmount(toBePaid, inputAmount);
      if (hasMaxAllowedAmount) {
        handleError(
          'Amount received is unusually high. Please confirm the entry.',
          'error',
          true,
        );
      } else if (inputAmount < toBePaid) {
        Keyboard.dismiss();
      } else {
        Keyboard.dismiss();
        payByCash(sanitized);
      }
    } else {
      console.log('inputAmount is ', inputAmount);
      console.log('toBePaid is ', toBePaid);
      handleError('Please enter a valid amount', 'error', true);
    }
  };

  const handleManualMpesaPayment = (amountOverride?: string) => {
    const amountStr = sanitizeNumericInput(
      (amountOverride ?? input).trim(),
      { isUnit: true },
    );
    const amountNum = Number(amountStr);
    if (!amountNum || amountNum <= 0 || Number.isNaN(amountNum)) {
      handleError('Please enter a valid amount', 'error', true);
      return;
    }
    if (toBePaid && amountNum < toBePaid) {
      handleError('Please enter a valid amount', 'error', true);
      return;
    }
    Keyboard.dismiss();
    payByCash(amountStr);
  };

  const keyboardDidHideCallback = () => {
    setKeyboardVisible(false);
    if (localInputRef.current) {
      localInputRef.current.blur();
    }
  };

  const keyboardDidShowCallback = () => {
    setKeyboardVisible(true);
  };

  useEffect(() => {
    const keyboardDidHideSubscription = Keyboard.addListener(
      'keyboardDidHide',
      keyboardDidHideCallback,
    );

    const keyboardDidShowSubscription = Keyboard.addListener(
      'keyboardDidShow',
      keyboardDidShowCallback,
    );

    return () => {
      keyboardDidHideSubscription?.remove();
      keyboardDidShowSubscription?.remove();
    };
  }, []);

  const handleSetPaymentValues = (
    cash: boolean,
    mpesa: boolean,
    payLater: boolean = false,
  ) => {
    setPayment({
      cash: cash,
      mpesa: mpesa,
      payLater: payLater,
    });
    dispatch(
      setCheckoutPaymentSelection({
        cash,
        mpesa,
        payLater,
      }),
    );
    const nextMethod = cash
      ? 'cash'
      : mpesa
        ? 'mpesa'
        : payLater
          ? 'pay_later'
          : checkoutPaymentIntent?.method || 'cash';
    dispatch(
      setCheckoutPaymentIntent({
        method: nextMethod,
      }),
    );
  };
  // const handleMpesaSheetChanges = (index: number) => {
  //   if (index === -1) {
  //     handleSetPaymentValues(true, false);
  //   } else {
  //     handleSetPaymentValues(false, true);
  //   }
  // };

  // useEffect(() => {
  //   if (payment.mpesa) {
  //     MpesaBottomSheetModalRef.current?.present();
  //   } else {
  //     MpesaBottomSheetModalRef.current?.dismiss();
  //   }
  // }, [payment.mpesa]);

  const totalAmount = order.reduce((acc: number, item: any) => {
    const priceType = item.bp_product_information?.bp_product_price_type;
    const quantity =
      item.bp_order_quantity - (item.bp_order_paid_quantity ?? 0);
    const mass = item.bp_order_mass - (item.bp_order_paid_mass ?? 0);

    return (
      acc +
      item.bp_product_information?.bp_product_selling_price *
        (priceType === 'unit' ? mass : quantity)
    );
  }, 0);

  // Remove the animatedScrollViewStyle since we're not using animations
  // const animatedScrollViewStyle = useAnimatedStyle(() => {
  //   return {
  //     paddingBottom: keyboardHeight,
  //   };
  // });

  const handleMpesaSheetChanges = (index: number) => {
    setBottomSheetIndex(index);
    // We no longer auto-toggle payment mode based on sheet visibility.
    // This handler is kept only to satisfy the bottom sheet API.
    if (index === -1) {
      // Sheet dismissed
      return;
    }
  };

  // Minimize bottom sheet when keyboard is dismissed
  useEffect(() => {
    const keyboardDidHideListener = Keyboard.addListener(
      'keyboardDidHide',
      () => {
        if (bottomSheetIndex >= 0 && MpesaBottomSheetModalRef.current) {
          MpesaBottomSheetModalRef.current.snapToIndex(0);
        }
      },
    );

    return () => {
      keyboardDidHideListener.remove();
    };
  }, [bottomSheetIndex]);

  const fetchUnapprovedMpesaTransactions = async () => {
    setIsFetchingTx(true);
    try {
      // Page 1, limit 100
      const res = await getUnapprovedMpesaPayments(
        axiosprivate as any,
        1,
        100,
        { accessToken: auth?.accessToken },
      );
      console.log('fetchUnapprovedMpesaTransactions response is ', res);
      if (res?.data?.status === 200) {
        const docs =
          res?.data?.data?.docs ||
          res?.data?.data?.data ||
          res?.data?.data ||
          [];
        dispatch(addMpesaPayments(docs));
      } else {
        console.log(
          'fetchUnapprovedMpesaTransactions error',
          res?.data?.message,
        );
        handleError(
          String(res?.data?.message || 'Failed to load Mpesa transactions'),
          'error',
          true,
        );
      }
    } catch (e: any) {
      console.log('fetchUnapprovedMpesaTransactions error', e?.message);
      handleError('Error fetching Mpesa transactions', 'error', true);
    } finally {
      setIsFetchingTx(false);
    }
  };

  const requestMpesaStkPush = async () => {
    const normalizedPhone = normalizeSafaricomPhone(mpesaPhone);
    if (!safaricomNumberValidation(normalizedPhone)) {
      handleError('Enter a valid Safaricom number', 'error', true);
      return;
    }
    const phone = normalizedPhone;
    setIsSendingStk(true);
    try {
      const response = await makeMpesaStkPush(
        axiosprivate as any,
        {
          bp_order_id: orderID,
          bp_phone_number: phone,
        },
        { accessToken: auth?.accessToken },
      );
      console.log('requestMpesaStkPush response is ', response);
      if (response?.data?.status === 200) {
        dispatch(
          setCheckoutPaymentIntent({
            method: 'mpesa',
            mpesa: {
              phone,
              stkStatus: 'sent',
              lastRequestedAt: new Date().toISOString(),
            },
          }),
        );
        handleError('STK push sent', 'success', true);
      } else {
        handleError(
          String(response?.data?.message || 'STK push failed'),
          'error',
          true,
        );
        dispatch(
          setCheckoutPaymentIntent({
            mpesa: {
              stkStatus: 'error',
            },
          }),
        );
      }
    } catch (e: any) {
      console.log('requestMpesaStkPush error', e?.message);
      handleError('STK push request failed', 'error', true);
      dispatch(
        setCheckoutPaymentIntent({
          mpesa: {
            stkStatus: 'error',
          },
        }),
      );
    } finally {
      setIsSendingStk(false);
    }
  };

  const confirmMpesaPayment = async (phoneRaw: string) => {
    const phone = normalizeSafaricomPhone(phoneRaw);
    setConfirmingPhone(phone);
    try {
      const response = await checkMpesaPaymentsByPhone(
        axiosprivate as any,
        {
          bp_phone_number: phone,
          bp_order_id: orderID,
        },
        { accessToken: auth?.accessToken },
      );
      console.log('confirmMpesaPayment response is ', response);
      if (response?.data?.status === 200) {
        // Treat like a successful payment (mimic cash flow)
        setPaymentInfo(response.data.data);
        setPayment_Information(response.data.data.payment);
        setReceipt(prev => ({
          ...prev,
          Payment_Information: response.data.data.payment,
        }));
        // Capture amounts before PaymentModal mounts and ClearCart runs.
        const amountPaidNum = Number(
          response?.data?.data?.payment?.bp_payment_amount_received ??
            toBePaid,
        );
        appAnalytics.track('commerce_checkout_completed', {
          ...buildAppAnalyticsContext({
            role: employeeRole,
            locationType: currentLocation?.bp_location_is_system_generated
              ? 'test'
              : currentLocation
                ? 'real'
                : undefined,
          }),
          item_count: order?.length,
          amount_paid: Number.isFinite(amountPaidNum)
            ? amountPaidNum
            : undefined,
          order_total:
            Payment_Information?.bp_payment_amount ??
            payment_Info?.bp_payment_amount,
          payment_method: 'mpesa',
          // confirmMpesaPayment is till/latest-tx path, not STK confirm.
          mpesa_mode: 'paid_to_till',
          order_id: orderID,
          flow: 'standard',
        });
        // T077: terminal real-location standard sale success → First sale.
        reportSaleActivation({
          flow: 'standard',
          responseStatus: response?.data?.status,
          paymentStatus: response?.data?.data?.payment?.bp_payment_status,
          locationId,
          locationType: currentLocation?.bp_location_is_system_generated
            ? 'test'
            : 'real',
        });
        dispatch(clearOrderDetails());
        dispatch(resetCheckoutPaymentIntent());
        setPaymentModal(true);
        // Switch to cash and close sheet
        handleSetPaymentValues(true, false);
        MpesaBottomSheetModalRef.current?.dismiss();
      } else {
        handleError(
          String(response?.data?.message || 'Payment not found/confirmed'),
          'error',
          true,
        );
      }
    } catch (e: any) {
      console.log('confirmMpesaPayment error', e?.message);
      handleError('Failed to confirm payment', 'error', true);
    } finally {
      setConfirmingPhone(null);
    }
  };

  const isToday = (dateInput: any) => {
    if (!dateInput) return false;
    const d = new Date(dateInput);
    const now = new Date();
    return (
      d.getFullYear() === now.getFullYear() &&
      d.getMonth() === now.getMonth() &&
      d.getDate() === now.getDate()
    );
  };

  const todaysPayments = mpesaPayments?.filter((p: any) => {
    // Field seen in MpesaPayments.tsx
    const when =
      p?.bp_mpesa_payment_transaction_date || p?.createdAt || p?.bp_created_at;
    return isToday(when);
  });

  const mpesaStkCtaLabel =
    checkoutPaymentIntent?.mpesa?.stkStatus === 'sent'
      ? 'Resend STK Push'
      : 'Send STK Push';

  const handleMpesaPhoneChange = (nationalValue: string) => {
    const startsWithZero = nationalValue.startsWith('0');
    if (startsWithZero) {
      nationalValue = nationalValue.slice(1);
    }
    setPhoneInputValue(nationalValue);
    const full = buildE164FromInput(
      nationalValue,
      phoneSelectedCountry || phoneInputRef.current?.getCountry?.(),
    );
    // We still want to keep mpesaPhone as the normalized safaricom version for validation/sending
    setMpesaPhone(full);
  };

  const handleMpesaCountryChange = (country: ICountry) => {
    setPhoneSelectedCountry(country);
    const full = buildE164FromInput(phoneInputValue, country);
    setMpesaPhone(full);
  };

  return (
    <>
      <KeyboardAwareFormScroll
        style={styles.scrollViewContent}
        bottomOffset={v(180)}
        // baseBottomPadding={v(10)}
        contentContainerStyle={styles.scrollContainer}
        keyboardShouldPersistTaps="handled"
        // extraKeyboardSpace={20}
      >
        <View style={{ flex: 1 }}>
          <TestLocationBanner variant="subtle" />
          <Receipt
            screenName="CheckoutScreen"
            order={order}
            Payment_Information={Payment_Information}
            minHeightFactor={0.35}
            maxHeightFactor={0.6}
          />

          {settings?.allow_partial_orders ? (
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                gap: s(8),
                marginTop: v(40),
                justifyContent: 'center',
              }}>
              {order?.length > 1 ||
              order?.some((item: any) => {
                const remainingQty =
                  item.bp_order_quantity - (item.bp_order_paid_quantity ?? 0);
                const remainingMass =
                  item.bp_order_mass - (item.bp_order_paid_mass ?? 0);
                return remainingQty > 1 || remainingMass > 0;
              }) ? (
                <TouchableOpacity
                  onPress={() => {
                    setPayForSelectedItemsOnly(!payForSelectedItemsOnly);
                  }}
                  style={styles.checkboxContainer}>
                  {payForSelectedItemsOnly ? (
                    <Feather
                      name="check-square"
                      size={24}
                      color={theme.colors.successDark}
                    />
                  ) : (
                    <Feather
                      name="square"
                      size={24}
                      color={theme.colors.text}
                    />
                  )}
                  <Typography
                    style={{
                      fontSize: fs(16),
                      fontFamily: GTFonts.regular,
                      lineHeight: fs(18),
                      color: payForSelectedItemsOnly
                        ? theme.colors.successDark
                        : theme.colors.text,
                    }}>
                    Pay For Specific Products only
                  </Typography>
                </TouchableOpacity>
              ) : null}
            </View>
          ) : null}

          {paymentModal ? (
            <PaymentModal
              orderID={orderID}
              navigation={navigation}
              paymentInfo={paymentInfo}
            />
          ) : null}
          {isloading && <Indicator isloading={isloading} />}
        </View>
      </KeyboardAwareFormScroll>

      {/* Checkout payment bottom sheet (cash or Mpesa) */}
      <CustomBottomSheet
        //@ts-ignore
        bottomSheetModalRef={MpesaBottomSheetModalRef}
        snapPoints={['60%', '90%']}
        enableDynamicSizing={false}
        handleSheetChanges={handleMpesaSheetChanges}
        constrainWidth
        footer={
          checkoutSheetTab !== 'PAYMENTS' ? undefined : payment.cash ? (
            <View style={styles.sheetFooter}>
              <Button
                text={`Confirm Cash Payment - ${currencyTextCapital} ${formatWithCommas(toBePaid ?? 0)}`}
                height={v(44)}
                fontSize={fs(14)}
                borderRadius={s(8)}
                backgroundColor={
                  input && Number(input) > 0
                    ? theme.colors.success
                    : theme.colors.borderGray
                }
                disabled={!input || Number(input) < (toBePaid ?? 0)}
                onPress={() => {
                  MpesaBottomSheetModalRef.current?.dismiss();
                  handlePaybyCash();
                }}
              />
            </View>
          ) : payment.mpesa &&
            mpesaActiveTab === 'LATEST' &&
            !mpesaconfigured ? (
            <View style={styles.sheetFooter}>
              <Button
                text={`Confirm Mpesa Till Payment - ${currencyTextCapital} ${formatWithCommas(toBePaid ?? 0)}`}
                height={v(44)}
                borderRadius={s(8)}
                fontSize={fs(14)}
                backgroundColor={
                  input && Number(input) > 0 && Number(input) >= (toBePaid ?? 0)
                    ? theme.colors.success
                    : theme.colors.borderGray
                }
                disabled={
                  !input ||
                  Number(input) <= 0 ||
                  Number(input) < (toBePaid ?? 0)
                }
                onPress={() => {
                  MpesaBottomSheetModalRef.current?.dismiss();
                  handleManualMpesaPayment();
                }}
              />
            </View>
          ) : payment.mpesa && mpesaActiveTab === 'STK' ? (
            <View style={styles.sheetFooter}>
              <Button
                text={
                  isSendingStk
                    ? `Sending... - ${currencyTextCapital} ${formatWithCommas(toBePaid ?? 0)}`
                    : `${mpesaStkCtaLabel} - ${currencyTextCapital} ${formatWithCommas(toBePaid ?? 0)}`
                }
                height={v(44)}
                fontSize={fs(14)}
                borderRadius={s(8)}
                backgroundColor={
                  safaricomNumberValidation(
                    normalizeSafaricomPhone(mpesaPhone),
                  ) && mpesaconfigured
                    ? theme.colors.success
                    : theme.colors.graphite
                }
                disabled={
                  !safaricomNumberValidation(
                    normalizeSafaricomPhone(mpesaPhone),
                  ) ||
                  isSendingStk ||
                  !mpesaconfigured
                }
                onPress={requestMpesaStkPush}
              />
            </View>
          ) : undefined
        }>
        <View style={styles.sheetContent}>
          <Text style={styles.sheetTitle}>Select Payment Method</Text>
          <View style={styles.sheetTopTabRow}>
            <Pressable
              onPress={() => setCheckoutSheetTab('PAYMENTS')}
              style={[
                styles.sheetTopTabItem,
                checkoutSheetTab === 'PAYMENTS' && styles.sheetTopTabItemActive,
              ]}>
              <Text
                style={[
                  styles.sheetTopTabText,
                  checkoutSheetTab === 'PAYMENTS' && styles.sheetTopTabTextActive,
                ]}>
                Payments
              </Text>
            </Pressable>
            <Pressable
              onPress={() => setCheckoutSheetTab('CUSTOMER_STAFF')}
              style={[
                styles.sheetTopTabItem,
                checkoutSheetTab === 'CUSTOMER_STAFF' &&
                  styles.sheetTopTabItemActive,
              ]}>
              <Text
                style={[
                  styles.sheetTopTabText,
                  checkoutSheetTab === 'CUSTOMER_STAFF' &&
                    styles.sheetTopTabTextActive,
                ]}>
                Customer & Staff
              </Text>
            </Pressable>
          </View>

          {checkoutSheetTab === 'PAYMENTS' ? (
            <>
              <View style={styles.paymentOptionRow}>
            <TouchableOpacity
              activeOpacity={0.85}
              onPress={() => handleSetPaymentValues(true, false)}
              style={[
                styles.paymentOptionCard,
                payment.cash && styles.paymentOptionCardActive,
              ]}>
              <Image
                source={require('../../assets/cash.png')}
                style={styles.paymentOptionIcon}
              />
              <Text style={styles.paymentOptionLabel}>Cash</Text>
            </TouchableOpacity>
            <TouchableOpacity
              // Default Mpesa flow to "Paid to Till"
              activeOpacity={0.85}
              onPress={() => {
                handleSetPaymentValues(false, true);
                setMpesaActiveTab('LATEST');
                dispatch(
                  setCheckoutPaymentIntent({
                    method: 'mpesa',
                    mpesa: { mode: 'PAID_TO_TILL' },
                  }),
                );
                if (mpesaconfigured) {
                  fetchUnapprovedMpesaTransactions();
                }
              }}
              style={[
                styles.paymentOptionCard,
                payment.mpesa && styles.paymentOptionCardActive,
              ]}>
              <Image
                source={require('../../assets/mpesa.png')}
                style={styles.paymentOptionIcon}
              />
              <Text style={styles.paymentOptionLabel}>Mpesa</Text>
            </TouchableOpacity>
          </View>

          {payment.cash ? (
            <>
              <Text style={styles.sheetSectionTitle}>Amount received</Text>
              <BottomSheetTextInput
                style={styles.sheetTextInput}
                placeholder="Enter amount"
                placeholderTextColor={theme.colors.textSecondary}
                keyboardType="decimal-pad"
                value={formatNumericStringWithCommas(input)}
                onChangeText={raw => {
                  const sanitized = sanitizeNumericInput(raw, { isUnit: true });
                  setInput(sanitized);
                }}
              />
            </>
          ) : (
            <>
              <View style={styles.sheetHeader}>
                {!mpesaconfigured ? (
                  <>
                    <Pressable
                      onPress={() => {
                        setMpesaActiveTab('LATEST');
                      }}
                      style={[
                        styles.tabItem,
                        mpesaActiveTab === 'LATEST' && styles.tabItemActive,
                      ]}>
                      <Text
                        style={[
                          styles.tabText,
                          mpesaActiveTab === 'LATEST' && styles.tabTextActive,
                        ]}>
                        Manual
                      </Text>
                    </Pressable>
                    <Pressable
                      onPress={() => {
                        setMpesaActiveTab('STK');
                      }}
                      style={[
                        styles.tabItem,
                        mpesaActiveTab === 'STK' && styles.tabItemActive,
                        { opacity: 0.5 },
                      ]}>
                      <Text
                        style={[
                          styles.tabText,
                          mpesaActiveTab === 'STK' && styles.tabTextActive,
                        ]}>
                        Send STK Prompt
                      </Text>
                    </Pressable>
                  </>
                ) : (
                  <>
                    <Pressable
                      onPress={() => {
                        setMpesaActiveTab('LATEST');
                        fetchUnapprovedMpesaTransactions();
                      }}
                      style={[
                        styles.tabItem,
                        mpesaActiveTab === 'LATEST' && styles.tabItemActive,
                      ]}>
                      <Text
                        style={[
                          styles.tabText,
                          mpesaActiveTab === 'LATEST' && styles.tabTextActive,
                        ]}>
                        Paid to Till
                      </Text>
                    </Pressable>
                    <Pressable
                      onPress={() => {
                        setMpesaActiveTab('STK');
                      }}
                      style={[
                        styles.tabItem,
                        mpesaActiveTab === 'STK' && styles.tabItemActive,
                      ]}>
                      <Text
                        style={[
                          styles.tabText,
                          mpesaActiveTab === 'STK' && styles.tabTextActive,
                        ]}>
                        Send STK Prompt
                      </Text>
                    </Pressable>
                  </>
                )}
              </View>

              {mpesaActiveTab === 'STK' ? (
                <View style={styles.sheetMpesaContent}>
                  {!mpesaconfigured && (
                    <Text
                      style={{
                        color: theme.colors.error,
                        fontSize: fs(12),
                        lineHeight: fs(16),
                        marginBottom: v(10),
                        textAlign: 'center',
                        fontFamily: GTFonts.regular,
                      }}>
                      Please Configure Mpesa to use STK Push
                    </Text>
                  )}
                  <Typography style={styles.sheetLabel}>
                    Customer Mpesa number
                  </Typography>
                  <View
                    pointerEvents={!mpesaconfigured ? 'none' : 'auto'}
                    style={{
                      backgroundColor: theme.colors.surface,
                      height: v(50),
                      marginBottom: v(6),
                      borderRadius: s(10),
                      borderWidth: StyleSheet.hairlineWidth,
                      borderColor: theme.colors.borderGray,
                      flexDirection: 'row',
                      alignItems: 'center',
                      opacity: !mpesaconfigured ? 0.5 : 1,
                    }}>
                    <PhoneInput
                      ref={phoneInputRef}
                      defaultCountry={countryCode as any}
                      value={phoneInputValue}
                      modalType="bottomSheet"
                      placeholder="720 222 222"
                      onPress={() => MpesaBottomSheetModalRef.current?.expand()}
                      minBottomsheetHeight={'50%'}
                      initialBottomsheetHeight={'80%'}
                      maxBottomsheetHeight={'92%'}
                      popularCountries={PREFERRED_COUNTRIES}
                      modalPopularCountriesTitle="Popular countries"
                      modalAllCountriesTitle="All countries"
                      onChangePhoneNumber={handleMpesaPhoneChange}
                      country={phoneSelectedCountry}
                      onChangeCountry={handleMpesaCountryChange}
                      phoneInputStyles={{
                        container: {
                          backgroundColor: 'transparent',
                          height: '100%',
                          alignItems: 'center',
                        },
                        flagContainer: {
                          paddingHorizontal: s(8),
                        },
                        divider: {
                          width: borderWidth(Platform.OS === 'web' ? 0.5 : 1),
                        },
                        input: {
                          fontFamily: GTFonts.semibold,
                          fontSize: fs(16),
                          lineHeight: fs(18),
                          ...(Platform.OS === 'web' && {
                            outlineStyle: 'none',
                          }),
                        } as any,
                        callingCode: {
                          fontFamily: GTFonts.semibold,
                          fontSize: fs(16),
                          lineHeight: fs(18),
                        },
                      }}
                    />
                  </View>
                  {!safaricomNumberValidation(
                    normalizeSafaricomPhone(mpesaPhone),
                  ) && mpesaPhone.length > 0 ? (
                    <Text style={styles.validationText}>
                      Enter a valid Safaricom number
                    </Text>
                  ) : null}
                </View>
              ) : !mpesaconfigured ? (
                <View style={styles.sheetMpesaContent}>
                  <Text style={styles.sheetSectionTitle}>Amount received</Text>
                  <BottomSheetTextInput
                    style={styles.sheetTextInput}
                    placeholder="Enter amount"
                    placeholderTextColor={theme.colors.textSecondary}
                    keyboardType="decimal-pad"
                    value={formatNumericStringWithCommas(input)}
                    onChangeText={raw => {
                      const sanitized = sanitizeNumericInput(raw, { isUnit: true });
                      setInput(sanitized);
                    }}
                  />
                </View>
              ) : (
                <View style={{ flex: 1 }}>
                  {isFetchingTx ? (
                    <View style={styles.txLoadingContainer}>
                      <ActivityIndicator
                        size="small"
                        color={theme.colors.primary}
                      />
                    </View>
                  ) : (
                    <FlatList
                      data={todaysPayments}
                      keyExtractor={(item: any) =>
                        String(
                          item?._id ||
                            item?.bp_mpesa_payment_id ||
                            Math.random(),
                        )
                      }
                      contentContainerStyle={styles.txListContent}
                      renderItem={({ item }) => {
                        const phone =
                          item?.bp_mpesa_payment_phone_number ||
                          item?.bp_phone_number ||
                          '';
                        const amount =
                          item?.bp_mpesa_payment_amount ||
                          item?.amount ||
                          item?.bp_amount ||
                          0;
                        const isRowConfirming =
                          confirmingPhone &&
                          normalizeSafaricomPhone(phone) === confirmingPhone;
                        return (
                          <View style={styles.txRow}>
                            <View style={styles.txInfo}>
                              <Text style={styles.txPhone}>{phone}</Text>
                              <Text style={styles.txAmount}>
                                KSh {formatWithCommas(Number(amount))}
                              </Text>
                            </View>
                            <View style={styles.txAction}>
                              <Button
                                text={
                                  isRowConfirming ? 'Confirming...' : 'Confirm'
                                }
                                height={v(36)}
                                borderRadius={s(8)}
                                backgroundColor={theme.colors.success}
                                rippleColor={theme.colors.textGray900}
                                disabled={!!isRowConfirming}
                                onPress={() => confirmMpesaPayment(phone)}
                              />
                            </View>
                          </View>
                        );
                      }}
                      ListEmptyComponent={
                        <View style={styles.emptyTxContainer}>
                          <Text style={styles.emptyTxText}>
                            {!mpesaconfigured
                              ? 'Please configure Mpesa to verify paid transactions'
                              : 'No transactions found for today'}
                          </Text>
                        </View>
                      }
                    />
                  )}
                </View>
              )}
            </>
          )}
            </>
          ) : (
            <OrderCustomerStaffSection
              input={customerTabInput}
              isLoadingOrder={isloading}
              showCustomerDropdown={showCustomerDropdown}
              filteredCustomers={filteredCustomers}
              setInput={setCustomerTabInput}
              onCustomerInputFocus={() => setShowCustomerDropdown(true)}
              onSubmitName={() => Keyboard.dismiss()}
              onSelectCustomer={(name) => {
                setCustomerTabInput(name);
                setShowCustomerDropdown(false);
                Keyboard.dismiss();
              }}
              shouldShowStaffSection={shouldShowStaffSection}
              staffQuery={staffQuery}
              setStaffQuery={setStaffQuery}
              isLoadingStaff={assignableStaffEntry.loading}
              filteredStaff={filteredStaff}
              assignedStaffId={assignedStaffId}
              toggleStaffSelection={id =>
                setAssignedStaffId(prev => (prev === id ? null : id))
              }
            />
          )}
        </View>
      </CustomBottomSheet>

      <KeyboardStickyView offset={{ closed: 0, opened: 30 }}>
        <View style={styles.stickyButtonContainer}>
          {payForSelectedItemsOnly ? (
            <Button
              text="Continue"
              fontSize={fs(14)}
              rippleColor={theme.colors.primaryDark}
              borderRadius={s(8)}
              height={v(46)}
              disabled={!networkAvailableGlobal}
              backgroundColor={theme.colors.success}
              onPress={() => {
                dispatch(
                  addPartialPaymentsDetails({
                    order: order,
                    orderID: orderID,
                    ReceiptID: ReceiptID,
                    loading: isloading,
                    orderCustomerName: orderCustomerName,
                    toBePaid: toBePaid,
                    alreadyPaid:
                      Payment_Information.bp_payment_already_paid_amount,
                    fullOrderTotal: Payment_Information.bp_payment_amount,
                  }),
                );
                Keyboard.dismiss();
                navigation.navigate('PartialOrdersSelectItems');
              }}
            />
          ) : checkoutPaymentIntent?.method === 'cash' &&
            checkoutPaymentIntent?.cashAmount &&
            Number(checkoutPaymentIntent.cashAmount) >= (toBePaid ?? 0) ? (
            <View style={styles.splitButtonContainer}>
              <TouchableOpacity
                style={[
                  styles.splitButtonMain,
                  !networkAvailableGlobal && styles.splitButtonDisabled,
                ]}
                disabled={!networkAvailableGlobal || isloading}
                // activeOpacity={0.8}
                onPress={() => {
                  setInput(
                    sanitizeNumericInput(
                      checkoutPaymentIntent.cashAmount || '',
                      { isUnit: true },
                    ),
                  );
                  handlePaybyCash();
                }}>
                <Text style={styles.splitButtonText}>
                  {isloading
                    ? 'Processing...'
                    : `Confirm Cash Payment - ${currencyTextCapital} ${formatWithCommas(Number(checkoutPaymentIntent.cashAmount))}`}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  styles.splitButtonEdit,
                  !networkAvailableGlobal && styles.splitButtonDisabled,
                ]}
                disabled={!networkAvailableGlobal}
                activeOpacity={0.8}
                onPress={() => MpesaBottomSheetModalRef.current?.present()}>
                <Feather
                  name="edit-2"
                  size={iconSize(18)}
                  color={theme.colors.surface}
                />
              </TouchableOpacity>
            </View>
          ) : checkoutPaymentIntent?.method === 'mpesa' &&
            !mpesaconfigured &&
            checkoutPaymentIntent?.mpesa?.mode === 'PAID_TO_TILL' &&
            checkoutPaymentIntent?.cashAmount &&
            Number(checkoutPaymentIntent.cashAmount) >= (toBePaid ?? 0) ? (
            <View style={styles.splitButtonContainer}>
              <TouchableOpacity
                style={[
                  styles.splitButtonMain,
                  (!networkAvailableGlobal || isloading) &&
                    styles.splitButtonDisabled,
                ]}
                disabled={!networkAvailableGlobal || isloading}
                activeOpacity={0.8}
                onPress={() => {
                  setInput(
                    sanitizeNumericInput(
                      checkoutPaymentIntent.cashAmount || '',
                      { isUnit: true },
                    ),
                  );
                  handleManualMpesaPayment(checkoutPaymentIntent.cashAmount);
                }}>
                <Text style={styles.splitButtonText}>
                  {isloading
                    ? 'Processing...'
                    : `Confirm Mpesa Till Payment - ${currencyTextCapital} ${formatWithCommas(Number(checkoutPaymentIntent.cashAmount))}`}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  styles.splitButtonEdit,
                  !networkAvailableGlobal && styles.splitButtonDisabled,
                ]}
                disabled={!networkAvailableGlobal}
                activeOpacity={0.8}
                onPress={() => MpesaBottomSheetModalRef.current?.present()}>
                <Feather
                  name="edit-2"
                  size={iconSize(18)}
                  color={theme.colors.surface}
                />
              </TouchableOpacity>
            </View>
          ) : checkoutPaymentIntent?.method === 'mpesa' &&
            checkoutPaymentIntent?.mpesa?.phone &&
            safaricomNumberValidation(
              normalizeSafaricomPhone(checkoutPaymentIntent.mpesa.phone),
            ) ? (
            <View style={styles.splitButtonContainer}>
              <TouchableOpacity
                style={[
                  styles.splitButtonMain,
                  (!networkAvailableGlobal || !mpesaconfigured) &&
                    styles.splitButtonDisabled,
                ]}
                disabled={
                  !networkAvailableGlobal || isSendingStk || !mpesaconfigured
                }
                activeOpacity={0.8}
                onPress={() => {
                  setMpesaPhone(checkoutPaymentIntent.mpesa?.phone || '');
                  requestMpesaStkPush();
                }}>
                <Text style={styles.splitButtonText}>
                  {isSendingStk
                    ? 'Sending...'
                    : `${mpesaStkCtaLabel} - ${currencyTextCapital} ${formatWithCommas(toBePaid ?? 0)}`}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  styles.splitButtonEdit,
                  !networkAvailableGlobal && styles.splitButtonDisabled,
                ]}
                disabled={!networkAvailableGlobal}
                activeOpacity={0.8}
                onPress={() => MpesaBottomSheetModalRef.current?.present()}>
                <Feather
                  name="edit-2"
                  size={iconSize(18)}
                  color={theme.colors.surface}
                />
              </TouchableOpacity>
            </View>
          ) : (
            <Button
              text="Pay Now"
              fontSize={fs(14)}
              rippleColor={theme.colors.textGray600}
              borderRadius={s(8)}
              height={v(46)}
              disabled={!networkAvailableGlobal}
              backgroundColor={theme.colors.success}
              onPress={() => MpesaBottomSheetModalRef.current?.present()}
            />
          )}
        </View>
      </KeyboardStickyView>
    </>
  );
};

export { Checkout };

function createCheckoutStyles(constrainWidth: boolean) {
  return StyleSheet.create({
    scrollViewContent: {
      flex: 1,
      backgroundColor: theme.colors.background,
      ...(constrainWidth && {
        maxWidth: WEB_MAX_CONTENT_WIDTH,
        alignSelf: 'center',
        width: '100%',
        paddingHorizontal: s(24),
      }),
    },
    scrollContainer: {
      flexGrow: 1,
    },
    checkboxContainer: {
      alignItems: 'center',
      flexDirection: 'row',
      gap: s(8),
    },
    checkboxInner: {
      width: s(12),
      height: v(12),
      backgroundColor: theme.colors.primaryDark,
      borderRadius: s(2),
    },
    top: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    total: {
      marginTop: v(10),
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    payment: {
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      width: '100%',
      paddingHorizontal: s(8),
    },
    paymentName: {
      justifyContent: 'center',
      alignSelf: 'center',
      fontSize: fs(16),
      lineHeight: fs(20),
      fontFamily: GTFonts.regular,
    },
    bottom: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    outline: {
      shadowColor: theme.colors.primaryDark,
      shadowOffset: {
        width: s(2),
        height: v(2),
      },
      shadowOpacity: 0.5,
      shadowRadius: s(Platform.OS === 'web' ? 0.5 : 1),
      elevation: 10,
    },
    none: {
      borderWidth: borderWidth(0),
    },
    input: {
      borderColor: theme.colors.primaryDark,
      borderWidth: 1,
      width: '85%',
      padding: s(8),
      height: v(45),
      backgroundColor: theme.colors.surface,
      fontSize: fs(16),
      borderRadius: s(8),
      marginTop: v(30),
      paddingLeft: s(15),
    },
    button: {
      borderRadius: s(8),
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: s(20),
    },
    text: {
      fontSize: fs(20),
      fontWeight: 'bold',
      color: 'white',
    },
    stickyButtonContainer: {
      backgroundColor: theme.colors.surface,
      paddingHorizontal: s(8),
      paddingVertical: s(20),
      borderTopWidth: 1,
      borderTopColor: theme.colors.borderGray200,
      ...(constrainWidth && {
        maxWidth: WEB_MAX_CONTENT_WIDTH,
        alignSelf: 'center',
        width: '100%',
        paddingHorizontal: s(24),
      }),
    },
    splitButtonContainer: {
      flexDirection: 'row',
      height: v(46),
      borderRadius: theme.borderRadius.md,
      overflow: 'hidden',
    },
    splitButtonMain: {
      flex: 0.8,
      backgroundColor: theme.colors.success,
      justifyContent: 'center',
      alignItems: 'center',
      borderRightWidth: 1,
      borderRightColor: theme.colors.surface,
    },
    splitButtonEdit: {
      flex: 0.2,
      backgroundColor: theme.colors.success,
      justifyContent: 'center',
      alignItems: 'center',
    },
    splitButtonText: {
      color: theme.colors.surface,
      fontSize: fs(14),
      lineHeight: fs(18),
      fontFamily: GTFonts.semibold,
    },
    splitButtonDisabled: {
      backgroundColor: theme.colors.borderGray,
    },
    // Bottom sheet styles
    sheetTitle: {
      fontFamily: GTFonts.regular,
      fontSize: fs(16),
      lineHeight: fs(20),
      color: theme.colors.text,
      textAlign: 'center',
      marginBottom: v(12),
    },
    sheetTopTabRow: {
      flexDirection: 'row',
      gap: s(8),
      marginBottom: v(12),
    },
    sheetTopTabItem: {
      flex: 1,
      borderWidth: borderWidth(1),
      borderColor: theme.colors.borderGray200,
      borderRadius: s(8),
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: s(10),
      backgroundColor: theme.colors.surface,
    },
    sheetTopTabItemActive: {
      backgroundColor: theme.colors.successLight,
      borderColor: theme.colors.successDark,
    },
    sheetTopTabText: {
      fontFamily: GTFonts.regular,
      fontSize: fs(14),
      lineHeight: fs(18),
      color: theme.colors.text,
    },
    sheetTopTabTextActive: {
      color: theme.colors.successDark,
      fontWeight: 'bold',
    },
    paymentOptionRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: v(16),
      gap: s(8),
    },
    paymentOptionCard: {
      flex: 1,
      borderWidth: 1,
      borderColor: theme.colors.borderGray200,
      borderRadius: s(8),
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: s(10),
      backgroundColor: theme.colors.surface,
    },
    paymentOptionCardActive: {
      borderColor: theme.colors.successDark,
      backgroundColor: theme.colors.successLight,
    },
    paymentOptionIcon: {
      width: s(70),
      height: v(28),
      marginBottom: v(6),
      resizeMode: 'contain',
    },
    paymentOptionLabel: {
      fontFamily: GTFonts.regular,
      fontSize: fs(14),
      lineHeight: fs(18),
      color: theme.colors.text,
    },
    sheetHeader: {
      flexDirection: 'row',
      gap: s(8),
      paddingHorizontal: s(8),
      paddingVertical: s(8),
    },
    tabItem: {
      flex: 1,
      borderWidth: 1,
      borderColor: theme.colors.borderGray200,
      borderRadius: s(8),
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: s(10),
      backgroundColor: theme.colors.surface,
    },
    tabItemActive: {
      backgroundColor: theme.colors.successLight,
      borderColor: theme.colors.successDark,
    },
    tabText: {
      fontFamily: GTFonts.regular,
      fontSize: fs(14),
      color: theme.colors.text,
    },
    tabTextActive: {
      color: theme.colors.successDark,
      fontWeight: 'bold',
    },
    sheetContent: {
      paddingHorizontal: s(12),
      paddingVertical: s(8),
    },
    sheetSectionTitle: {
      fontFamily: GTFonts.regular,
      fontSize: fs(14),
      lineHeight: fs(18),
      color: theme.colors.text,
      // marginBottom: v(16),
      marginTop: v(24),
    },
    sheetLabel: {
      fontFamily: GTFonts.regular,
      lineHeight: fs(18),
      fontSize: fs(14),
      color: theme.colors.text,
      marginBottom: v(6),
      marginTop: v(10),
    },
    sheetInput: {
      borderColor: theme.colors.primaryDark,
      borderWidth: 1,
      width: '100%',
      padding: s(8),
      height: v(45),
      backgroundColor: theme.colors.surface,
      fontSize: fs(16),
      borderRadius: s(8),
      paddingLeft: s(12),
    },
    sheetTextInput: {
      borderWidth: borderWidth(Platform.OS === 'web' ? 0.5 : 1),
      height: v(50),
      borderColor: theme.colors.borderGray,
      borderRadius: theme.borderRadius.md,
      paddingHorizontal: s(12),
      paddingVertical: s(10),
      fontFamily: GTFonts.regular,
      fontSize: fs(16),
      color: theme.colors.text,
      backgroundColor: theme.colors.surface,
    },
    validationText: {
      marginTop: v(6),
      color: theme.colors.error,
      fontFamily: GTFonts.regular,
      fontSize: fs(12),
    },
    sheetFooter: {
      paddingHorizontal: s(12),
      backgroundColor: theme.colors.surface,
    },
    sheetMpesaContent: {
      paddingHorizontal: s(12),
      paddingVertical: s(8),
    },
    txLoadingContainer: {
      paddingVertical: s(12),
    },
    txListContent: {
      paddingHorizontal: s(12),
      paddingVertical: s(6),
    },
    txRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingVertical: s(10),
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.border,
    },
    txInfo: {
      flexDirection: 'column',
      gap: v(2),
    },
    txPhone: {
      fontFamily: GTFonts.regular,
      fontSize: fs(14),
      color: theme.colors.text,
    },
    txAmount: {
      fontFamily: GTFonts.regular,
      fontSize: fs(14),
      color: theme.colors.textSecondary,
    },
    txAction: {
      marginLeft: s(12),
    },
    emptyTxContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: s(20),
    },
    emptyTxText: {
      fontFamily: GTFonts.regular,
      fontSize: fs(14),
      color: theme.colors.textSecondary,
      lineHeight: fs(18),
    },
  });
}
